import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { User, UserStatus } from 'api/models';
import { EmptyCell } from 'components/atoms/empty-cell';
import { BodyShort01 } from 'components/styles/typography';
import { Memberships } from 'stores/memberships';

const Text = styled.p`
  margin-bottom: 0;
`;

export const PendingStatusText = styled(Text)`
  ${BodyShort01};
  color: var(--orange-40);
`;

export const Status: FC<{
  status: UserStatus;
  user: User;
  memberships: Memberships;
}> = ({ status, user, memberships }) => {
  const membership = memberships.byUserId[user.userId];

  if (membership && membership.joinedAt) {
    return (
      <Text>
        <FormattedMessage
          id="invitation.joined_on"
          values={{ date: moment(membership.joinedAt).format('DD MMM') }}
        />
      </Text>
    );
  }

  if (status === UserStatus.Inactive) {
    return (
      <Text>
        <FormattedMessage id="Deactivated" />
      </Text>
    );
  }

  if (status === UserStatus.Invited) {
    return (
      <PendingStatusText>
        <FormattedMessage id="invitation.pending" />
      </PendingStatusText>
    );
  }

  return <EmptyCell />;
};
